import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { AzureBlobStorageService } from "../core/_services/azure-blob-storage.service";
import { ErrorDialogService } from "../core/_services/error-dialog/error-dialog.service";
import { RouteChangeConfirmationComponent } from "./components/route-change-confirmation/route-change-confirmation.component";

@Injectable()
export class sharedService {

  constructor(private blobService: AzureBlobStorageService,
    private http: HttpClient,
    private errorService: ErrorDialogService,
    private dialog: MatDialog
  ) {
  }

  openRouteConfirmation() {
    const dialogRef = this.dialog.open(RouteChangeConfirmationComponent, {
      maxHeight: "100%",
      maxWidth: "100%",
      disableClose: true,
      hasBackdrop: true
    });
    const result = dialogRef.afterClosed().toPromise();
    return result;
  }

  async getBlobFiles(url: string): Promise<any> {
    if (this.blobService.isSASAvailable) {
      return await this.http.get(url + '?' + this.blobService.sas, { responseType: 'blob' }).toPromise()
    } else {
      let sasToken;
      const res = await this.blobService.generateSasToken();
      sasToken = res.sas;
      if (sasToken) {
        return this.http.get(url + '?' + sasToken, { responseType: 'blob' }).toPromise();
      } else {
        console.error("Sas Token was not recieved");
        this.errorService.openDialog("Something went wrong. Please try again later");
      }
    }
  }
}
